<template>
<div>
	<div v-if="processing">
		Processing...
	</div>
	<div v-else>
		Done.
	</div>
</div>
</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			processing: true,
			procId: null,
			queryString: null
		}
	},
	created(){
		
	}, 
	mounted() {
		
		this.procId = this.$route.params.procid;
		this.queryString = this.$route.query;
		this.processProc();
	},
	methods: {
		processProc(){
			this.processing = false;
			var urlstr = this.$gstate.getApiBaseRootURL() + '/' + this.procId;
			this.axios.post(urlstr, this.queryString, this.$gstate.getAxiosHeaders())
				.then(response => {
					this.$gstate.log(response);
				})
				.catch(error => {
					this.$gstate.log(error);
				});
		}
	},
}

</script>

